export default __webpack_public_path__ + "700d9db1294a74d4c1ebb9ae3989e343.png";